import React, { useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import "./ProfilePage.scss";
import NameEditForm from "../components/NameEditForm";
import { getOptimizedAvatar } from "../utils/imageOptimization";

function ProfilePage() {
  const user = useSelector((state) => state.user);
  const navigate = useNavigate();
  const [isEditing, setIsEditing] = useState(false);

  const handleEditClick = () => {
    setIsEditing(!isEditing);
  };

  if (!user) {
    return (
      <div style={{ display: 'flex', justifyContent: 'center', marginTop: '50px' }}>
        <h4>Please Login</h4>
      </div>
    );
  }

  return (
    <div className="profile-page-container">
      {/* Header Background */}
      <div className="profile-header-bg"></div>

      <div className="profile-content">
        {/* Profile Card */}
        <div className="profile-card-top">
          <img src={getOptimizedAvatar(user.picture, 150)} alt="Profile" className="profile-image" />
          <h2 className="user-name">{user.name}</h2>
          <p className="user-email">{user.email}</p>
        </div>

        {/* Info Section */}
        <div className="profile-info-section">
          <h6 className="section-title">Personal Details</h6>
          
          <div className="info-card">
            <div className="info-row">
              <div className="icon-container">
                <i className="fas fa-user"></i>
              </div>
              <div className="info-text-container">
                <div>
                  <span className="info-label">Full Name</span>
                  <span className="info-value">{user.name}</span>
                </div>
                <button className="edit-button" onClick={handleEditClick}>
                  {isEditing ? "Cancel" : "Edit"}
                </button>
              </div>
            </div>
            
            {isEditing && (
              <div style={{ padding: '0 16px 12px 72px' }}>
                <NameEditForm onSuccess={() => setIsEditing(false)} />
              </div>
            )}

            <div className="divider"></div>

            <div className="info-row">
              <div className="icon-container">
                <i className="fas fa-envelope"></i>
              </div>
              <div className="info-text-container">
                <div>
                  <span className="info-label">Email</span>
                  <span className="info-value">{user.email}</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Account Actions / Danger Zone */}
        <div className="profile-info-section" style={{ marginTop: '20px' }}>
          <h6 className="section-title">Account Actions</h6>
          <div className="info-card" style={{ border: '1px solid #FEE2E2' }}>
            <div className="info-row">
              <div className="icon-container" style={{ backgroundColor: '#FEF2F2', color: '#EF4444' }}>
                🗑️
              </div>
              <div className="info-text-container">
                <div>
                  <span className="info-label" style={{ color: '#EF4444', fontWeight: '600' }}>Danger Zone</span>
                  <span className="info-value" style={{ fontSize: '14px', color: '#6B7280' }}>Permanently delete your account</span>
                </div>
                <button 
                  className="edit-button" 
                  style={{ color: '#EF4444' }} 
                  onClick={() => navigate("/deleteaccount")}
                >
                  Delete Account
                </button>
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>
  );
}

export default ProfilePage;
